<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M1,3C1,3,15,3,15,3C15,3,15,3,15,3C15.55,3,16,3.45,16,4C16,4,16,12,16,12C16,12.55,15.55,13,15,13C15,13,1,13,1,13C0.45,13,0,12.55,0,12C0,12,0,4,0,4C0,4,0,4,0,4C0,3.45,0.45,3,1,3C1,3,1,3,1,3C1,3,1,3,1,3ZM2,5C2,5,2,11,2,11C2,11,14,11,14,11C14,11,14,5,14,5C14,5,2,5,2,5C2,5,2,5,2,5ZM5,9C4.45,9,4,8.55,4,8C4,7.45,4.45,7,5,7C5.55,7,6,7.45,6,8C6,8.55,5.55,9,5,9C5,9,5,9,5,9ZM8,9C7.45,9,7,8.55,7,8C7,7.45,7.45,7,8,7C8.55,7,9,7.45,9,8C9,8.55,8.55,9,8,9C8,9,8,9,8,9ZM11,9C10.45,9,10,8.55,10,8C10,7.45,10.45,7,11,7C11.55,7,12,7.45,12,8C12,8.55,11.55,9,11,9C11,9,11,9,11,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'WidgetButton',
} as DefineComponent
</script>
